module.exports = __webpack_public_path__ + "static/media/downarrow.0529ba6b.svg";